import { IconType } from './type';

const IconNext = ({ width = 24, height = 24, fill = '#DB092D' }: IconType) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.45 0H6.95C3.11162 0 0 3.11162 0 6.95V16.45C0 20.2884 3.11162 23.4 6.95 23.4H16.45C20.2884 23.4 23.4 20.2884 23.4 16.45V6.95C23.4 3.11162 20.2884 0 16.45 0Z"
				fill={fill}
			/>
			<path
				d="M0 11.7V16.39C0 18.2465 0.737498 20.027 2.05025 21.3398C3.36301 22.6525 5.14348 23.39 7 23.39H16.37C18.2265 23.39 20.007 22.6525 21.3197 21.3398C22.6325 20.027 23.37 18.2465 23.37 16.39V11.7H0Z"
				fill="white"
			/>
		</svg>
	);
};

export default IconNext;
